export default "__VITE_ASSET__zcpvhdML__"